export function format(first: string, middle: string, last: string): string {
  return (first || '') + (middle ? ` ${middle}` : '') + (last ? ` ${last}` : '');
}

export function formatHREF(domain:string = null, href:string = null):string {
  if (href) {
    href = href.trim();
    href.endsWith('%20') && (href = href.slice(0,-3));
    if (!href.includes(domain) && !href.startsWith('http') && !href.includes('tel:')) {
      href = `https://${domain}${!href.startsWith('/') ? '/' : ''}${href}`;
    }
    !href.includes('?filter') && !href.includes('tel:') && !href.endsWith('/') && (href = `${href}/`);
    return href;
  }
  return '#';
}
